import * as React from 'react';
import { isImageValid } from '../utils';
import { Log } from '../sentry';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
	src?: string;
	fallbackSrc?: string;
}

const ImageWithFallback: React.FC<Props> = ({ src, fallbackSrc, alt = '', ...props }) => {
	const [isError, setIsError] = React.useState(false);

	const onLoad = () => {
		if (isError) {
			setIsError(true);
		}
	};

	const getImgRef = (img: HTMLImageElement) => {
		if (img?.complete && (img.naturalWidth || img.naturalHeight)) {
			onLoad();
		}
	};

	React.useEffect(() => {
		let isCurrentSrc = true;

		isImageValid(src).then(isValid => {
			if (!isValid && isCurrentSrc) {
				setIsError(true);

				Log({
					category: 'ImageWithFallback',
					level: 'warning',
					message: src
				});
			}
		});

		return () => {
			isCurrentSrc = false;
		};
	});

	React.useEffect(() => {
		onLoad();
	}, [src]);

	if (isError && !fallbackSrc) {
		return null;
	}

	return (
		<img
			ref={getImgRef}
			{...props}
			{...(isError && fallbackSrc ? { src: fallbackSrc } : { src: src, onLoad })}
			alt={alt}
		/>
	);
};

export default ImageWithFallback;
